import {useMutation, useQueryClient} from '@tanstack/react-query';

import {deleteParticipant} from '../api';
import {QUERY__PARTICIPANTS} from '../queryKeys';

export const useDeleteParticipant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteParticipant,
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: [QUERY__PARTICIPANTS]});
    },
  });
};
